import { apiConfig } from "core-lib/config/config";
import { DictType } from "core-lib/types/Helper";
import { MapDataType } from "core-lib/types/Map";
import { getMethod } from "core-lib/utils/apiV2";

const serializer = (data): MapDataType => ({
  lat: data.latitude,
  lng: data.longitude,
  state: data.state,
  stateCode: data.state_code,
  city: data.city,
  pincode: data.pincode,
  streetAddress: null,
  locality: data.area,
  houseNo: null,
  district: data?.district,
  infraCity:data?.infra_city,
  zoneName : data?.zone_name,
  stateId : data?.state_id
});

export function fetchAddressFromLatLng({
  lat,
  lng,
  pincode,
  radius=5000,
  requiredFields = ['latitude', 'longitude', 'pincode', 'city', 'state'],
}: DictType) {
  return new Promise<{ locationData?: MapDataType; error?: any }>((res) => {
    (async (lat, lng) => {
      const url = `${apiConfig('infra', 'v4')}/infra/location/details/`;
      const params: any = {};
      if (lat && lng) {
        params.search_type = 'geolocation_search';
        params.latitude = lat;
        params.longitude = lng;
        params.radius = radius;
      } else if (pincode) {
        params.search_type = 'pincode_search';
        params.pincode = pincode;
      }
      const { response, error } = await getMethod({ endPoint: url, params });
      if (response) {
        const resultElem = response.data?.results?.[0];
        if (resultElem) {
          const isValid = requiredFields.every((el) => resultElem[el]);
          if (isValid) {
            res({ locationData: serializer(resultElem) });
          } else {
            res({ error: 'Oops! we could not find location details' });
          }
        } else {
          res({ error: 'Oops! we could not find location details' });
        }
      }

      if (error) {
        res({ error });
      }
    })(lat, lng);
  });
}
